module.exports = __webpack_public_path__ + "img/gou.f0a3d79d.png";